import i18n from 'i18next';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

export const columns = [
  {
    id: 'categoryType',
    numeric: false,
    disablePadding: true,
    label: i18n.t('defectDetails.area'),
    needSorting: true,
  },
  {
    id: 'sectionName',
    numeric: false,
    disablePadding: false,
    label: i18n.t('defectDetails.part'),
    needSorting: true,
  },
  {
    id: 'info',
    numeric: false,
    disablePadding: false,
    label: i18n.t('defectDetails.defectDetails'),
    needSorting: true,
    width: '20%',
  },
  {
    id: 'mechanicComments',
    numeric: false,
    disablePadding: false,
    label: i18n.t('defectDetails.commentsByMechanic'),
    needSorting: true,
    width: '20%',
  },
  {
    id: 'mechanicFixStatus',
    numeric: false,
    disablePadding: true,
    label: i18n.t('defectDetails.fixStatus'),
    needSorting: true,
  },
  {
    id: 'driverComments',
    numeric: false,
    disablePadding: false,
    label: i18n.t('defectDetails.comments'),
    needSorting: true,
    width: '20%',
  },
  {
    id: 'driverApproved',
    numeric: false,
    disablePadding: true,
    label: i18n.t('defectDetails.status'),
    needSorting: true,
  },
  {
    id: 'viewPhoto',
    numeric: false,
    disablePadding: false,
    label: i18n.t('defectDetails.viewPhoto'),
    needSorting: false,
  },
];

export const woAddObj = {
  id: null,
  userId: null,
  vehicleIdPub: null,
  trailerIdPub: null,
  companyId: null,
  workOrderIdPub: null,
  file: null,
  errorMessage: null,
  editUpload: null,
  type: {
    name: 'WORK_ORDER_IMAGE',
    order: 600,
    fullName: 'Work Order Image',
    documentGroup: 'WORK_ORDER',
  },
  name: null,
  url: null,
  uploaded: null,
  expiration_date: null,
  doctype: 'WORK_ORDER',
};

export const unitType = [
  {
    label: 'Vehicle',
    value: 'VEHICLE',
  },
  {
    label: 'Trailer',
    value: 'TRAILER',
  },
];

export const typeRepair = [
  {
    label: 'Repair',
    value: 'REPAIR',
  },
  {
    label: 'Safety Repair',
    value: 'SAFETY_REPAIR',
  },
  {
    label: 'Maintainence',
    value: 'MAINTENANCE',
  },
];

export const status = [
  {
    value: 'NOT_STARTED',
    selected: false,
    img: mediaUrls.notstartedIcons,
    // selectedImg: mediaUrls.notstartedorangeIcons,
  },
  {
    value: 'AWAITING_PARTS',
    selected: false,
    img: mediaUrls.awaitinggreyIcons,
    // selectedImg: mediaUrls.awaitingorangeIcons,
  },
  {
    value: 'IN_PROGRESS',
    selected: false,
    img: mediaUrls.progressgreyIcons,
    // selectedImg: mediaUrls.progressorangeIcons,
  },
  {
    value: 'COMPLETED',
    selected: false,
    img: mediaUrls.completegreyIcons,
    // selectedImg: mediaUrls.completeorangeIcons,
  },
  {
    value: 'CLOSED',
    selected: false,
    img: mediaUrls.closedgreyIcons,
    // selectedImg: mediaUrls.closedOrangeIcons,
  },
];
